import { render, staticRenderFns } from "./UploadProductCard.vue?vue&type=template&id=e62680f8"
import script from "./UploadProductCard.vue?vue&type=script&lang=js"
export * from "./UploadProductCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports